export const PAGINE_GENERICHE = {
  "pronto-intervento-h24": {
    occhiello: "Attivi giorno e notte",
    titolo: "Pronto Intervento H24 in Lombardia",
    intro:
      "Un guasto non aspetta l'orario d'ufficio. SOS Riparazioni 24 è la centrale operativa multiservizio sempre attiva: idraulici, elettricisti, fabbri, spurghisti e tecnici caldaie pronti a partire in tutta la Lombardia, 24 ore su 24, festivi inclusi.",
    blocchi: [
      {
        t: "Cosa facciamo",
        d: "Cinque squadre specializzate e un unico numero: dalla perdita d'acqua al black-out, dalla porta bloccata alla caldaia in blocco. Una chiamata e il tecnico giusto parte subito.",
      },
      {
        t: "Quando chiamarci",
        d: "Ogni volta che un problema non può aspettare: allagamenti, mancanza di corrente, serrature rotte, scarichi intasati. Se è urgente per te, è urgente per noi.",
      },
      {
        t: "Dove arriviamo",
        d: "Milano, Monza, Como, Bergamo, Brescia e tutte le province lombarde: i tecnici sono già dislocati sul territorio e arrivano in pochi minuti.",
      },
    ],
    punti: [
      "Risposta di un operatore reale in pochi minuti, anche di notte",
      "Tecnici certificati, assicurati e con ricambi a bordo",
      "Preventivo chiaro e concordato prima dei lavori",
      "Attivi weekend, festivi e notti, tutto l'anno",
    ],
  },
  "chi-siamo": {
    occhiello: "La nostra storia",
    titolo: "Chi siamo",
    intro:
      "SOS Riparazioni 24 nasce a Milano da un'idea semplice: nessuno dovrebbe restare ore — o giorni — con un guasto in casa o in negozio. Per questo abbiamo costruito una rete di tecnici lombardi coordinata da una centrale operativa che non dorme mai.",
    blocchi: [
      {
        t: "La missione",
        d: "Essere il primo numero che viene in mente quando qualcosa si rompe: risposta immediata, tecnico in arrivo, problema risolto. Senza giri di telefonate e senza attese.",
      },
      {
        t: "I tecnici",
        d: "Lavoriamo solo con professionisti certificati, assicurati e con esperienza pluriennale: idraulici, elettricisti, fabbri, spurghisti e frigoristi selezionati uno a uno.",
      },
      {
        t: "Il territorio",
        d: "Siamo lombardi e lavoriamo solo in Lombardia: conosciamo le città, i quartieri e i condomini, e per questo arriviamo davvero in fretta.",
      },
    ],
    punti: [
      "Centrale operativa sempre presidiata da personale reale",
      "Squadre locali dislocate in ogni provincia lombarda",
      "Ricambi originali o equivalenti, con garanzia sul lavoro",
      "Prezzo concordato prima di iniziare, senza sorprese",
    ],
  },
  "come-funziona": {
    occhiello: "Semplice e veloce",
    titolo: "Come funziona",
    intro:
      "Tre passi ti separano dalla riparazione: ce li teniamo semplici, perché in emergenza nessuno ha voglia di moduli infiniti e attese al telefono.",
    blocchi: [
      {
        t: "01 · Chiamaci o scrivici",
        d: "Raccontaci il problema al telefono, in chat o dal modulo: un operatore reale risponde in pochi istanti, a qualsiasi ora del giorno e della notte.",
      },
      {
        t: "02 · Tecnico in arrivo",
        d: "Attiviamo subito il tecnico più vicino a te: conosci nome e orario di arrivo prima ancora che parta, e restiamo in contatto finché non è da te.",
      },
      {
        t: "03 · Problema risolto",
        d: "Riparazione eseguita con ricambi garantiti e prezzo concordato in anticipo. Paghi come preferisci: contanti, carta o bonifico.",
      },
    ],
    punti: [
      "Nessun costo nascosto: il prezzo lo conosci prima",
      "Conferma immediata dell'intervento, in chat o al telefono",
      "Pagamento con contanti, carta, bancomat o bonifico",
      "Garanzia sul lavoro eseguito",
    ],
  },
};
